function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { createRef } from 'react';
import PropTypes from 'prop-types';
import ServiceManager from './base/service-manager/service-manager';
import { guid } from '../util';
import ToastQueue from './toast.queue';
import ToastContainer from './toast-group.container';
import { ToastStatus } from './toast.schema';

var ToastManager = /*#__PURE__*/function (_ServiceManager) {
  _inherits(ToastManager, _ServiceManager);

  var _super = _createSuper(ToastManager);

  function ToastManager() {
    var _this;

    var _queue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new ToastQueue();

    _classCallCheck(this, ToastManager);

    _this = _super.call(this, _queue, 'span');

    _defineProperty(_assertThisInitialized(_this), "render", function (queue) {
      _this.flush( /*#__PURE__*/React.createElement(ToastContainer, {
        ref: _this.containerRef,
        onClose: _this.handleClose,
        toasts: queue,
        placement: "bottomLeft",
        className: _this.className,
        tmpl: _this.tmpl
      }), _this.flushCallback);
    });

    _defineProperty(_assertThisInitialized(_this), "flushCallback", function () {
      if (_this.initialCommand.length !== 0) {
        _this.initialCommand.forEach(function (cmd) {
          return cmd();
        });

        _this.initialCommand.length = 0;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "createToastInstance", function (props) {
      var key = props.key,
          _props$duration = props.duration,
          duration = _props$duration === void 0 ? ToastManager.DefaultDuration : _props$duration,
          _props$pauseable = props.pauseable,
          pauseable = _props$pauseable === void 0 ? ToastManager.DefaultPauseable : _props$pauseable;

      var _this$createSlice = _this.createSlice(key, duration),
          clearTimeout = _this$createSlice.clearTimeout,
          startTimeout = _this$createSlice.startTimeout;

      var nextProps = _objectSpread({
        closeable: ToastManager.DefaultClosable
      }, props, {
        clearTimeout: clearTimeout,
        duration: duration,
        pauseable: pauseable,
        startTimeout: startTimeout
      });

      _this.queue.add(nextProps);

      return key;
    });

    _this.containerRef = createRef();
    _this.initialCommand = [];

    _this.queue.subscribe(_this.render);

    return _this;
  }

  _createClass(ToastManager, [{
    key: "error",
    value: function error(props) {
      return this.createToastInstance(_objectSpread({}, props, {
        key: guid(),
        status: ToastStatus.Error
      }));
    }
  }, {
    key: "success",
    value: function success(props) {
      return this.createToastInstance(_objectSpread({}, props, {
        key: guid(),
        status: ToastStatus.Success
      }));
    }
  }, {
    key: "warning",
    value: function warning(props) {
      return this.createToastInstance(_objectSpread({}, props, {
        key: guid(),
        status: ToastStatus.Warning
      }));
    }
  }, {
    key: "info",
    value: function info(props) {
      return this.createToastInstance(_objectSpread({}, props, {
        key: guid(),
        status: ToastStatus.Info
      }));
    }
  }, {
    key: "closeAll",
    value: function closeAll() {
      this.queue.deleteAll();
    }
  }, {
    key: "getDuplicationKey",
    value: function getDuplicationKey(props) {
      return this.queue.getDuplicationKey(props);
    }
  }, {
    key: "setTemplate",
    value: function setTemplate(tmpl) {
      var _this2 = this;

      if (this.containerRef.current) {
        this.containerRef.current.replaceTemplate(tmpl);
      } else {
        this.initialCommand.push(function () {
          return _this2.containerRef.current.replaceTemplate(tmpl);
        });
      }

      this.tmpl = tmpl;
    }
  }]);

  return ToastManager;
}(ServiceManager);

_defineProperty(ToastManager, "propTypes", {
  className: PropTypes.string,
  style: PropTypes.object
});

_defineProperty(ToastManager, "DefaultDuration", 5000);

_defineProperty(ToastManager, "DefaultClosable", true);

_defineProperty(ToastManager, "DefaultPauseable", true);

export default ToastManager;